import SharpSansThinEOT from "./SharpSans-Thin.eot";
import SharpSansThinWOFF from "./SharpSans-Thin.woff";
import SharpSansThinWOFF2 from "./SharpSans-Thin.woff2";
import SharpSansThinItalicEOT from "./SharpSans-ThinItalic.eot";
import SharpSansThinItalicWOFF from "./SharpSans-ThinItalic.woff";
import SharpSansThinItalicWOFF2 from "./SharpSans-ThinItalic.woff2";

import SharpSansLightEOT from "./SharpSans-Light.eot";
import SharpSansLightWOFF from "./SharpSans-Light.woff";
import SharpSansLightWOFF2 from "./SharpSans-Light.woff2";
import SharpSansLightItalicEOT from "./SharpSans-LightItalic.eot";
import SharpSansLightItalicWOFF from "./SharpSans-LightItalic.woff";
import SharpSansLightItalicWOFF2 from "./SharpSans-LightItalic.woff2";

import SharpSansBookEOT from "./SharpSans-Book.eot";
import SharpSansBookWOFF from "./SharpSans-Book.woff";
import SharpSansBookWOFF2 from "./SharpSans-Book.woff2";
import SharpSansBookItalicEOT from "./SharpSans-BookItalic.eot";
import SharpSansBookItalicWOFF from "./SharpSans-BookItalic.woff";
import SharpSansBookItalicWOFF2 from "./SharpSans-BookItalic.woff2";

import SharpSansMediumEOT from "./SharpSans-Medium.eot";
import SharpSansMediumWOFF from "./SharpSans-Medium.woff";
import SharpSansMediumWOFF2 from "./SharpSans-Medium.woff2";
import SharpSansMediumItalicEOT from "./SharpSans-MediumItalic.eot";
import SharpSansMediumItalicWOFF from "./SharpSans-MediumItalic.woff";
import SharpSansMediumItalicWOFF2 from "./SharpSans-MediumItalic.woff2";

import SharpSansSemiboldEOT from "./SharpSans-Semibold.eot";
import SharpSansSemiboldWOFF from "./SharpSans-Semibold.woff";
import SharpSansSemiboldWOFF2 from "./SharpSans-Semibold.woff2";
import SharpSansSemiboldItalicEOT from "./SharpSans-SemiboldItalic.eot";
import SharpSansSemiboldItalicWOFF from "./SharpSans-SemiboldItalic.woff";
import SharpSansSemiboldItalicWOFF2 from "./SharpSans-SemiboldItalic.woff2";

import SharpSansBoldEOT from "./SharpSans-Bold.eot";
import SharpSansBoldWOFF from "./SharpSans-Bold.woff";
import SharpSansBoldWOFF2 from "./SharpSans-Bold.woff2";
import SharpSansBoldItalicEOT from "./SharpSans-BoldItalic.eot";
import SharpSansBoldItalicWOFF from "./SharpSans-BoldItalic.woff";
import SharpSansBoldItalicWOFF2 from "./SharpSans-BoldItalic.woff2";

import SharpSansExtraboldEOT from "./SharpSans-Extrabold.eot";
import SharpSansExtraboldWOFF from "./SharpSans-Extrabold.woff";
import SharpSansExtraboldWOFF2 from "./SharpSans-Extrabold.woff2";
import SharpSansExtraboldItalicEOT from "./SharpSans-ExtraboldItalic.eot";
import SharpSansExtraboldItalicWOFF from "./SharpSans-ExtraboldItalic.woff";
import SharpSansExtraboldItalicWOFF2 from "./SharpSans-ExtraboldItalic.woff2";

import * as CSS from "csstype";

const SharpSans: CSS.FontFace[] = [
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Thin Regular'), url(${SharpSansThinEOT}?#iefix) format('embedded-opentype'), url(${SharpSansThinWOFF}) format('woff'), url(${SharpSansThinWOFF2}) format('woff2')`,
		fontWeight: 100,
		fontStyle: "normal"
	},
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Thin Italic'), url(${SharpSansThinItalicEOT}?#iefix) format('embedded-opentype'), url(${SharpSansThinItalicWOFF}) format('woff'), url(${SharpSansThinItalicWOFF2}) format('woff2')`,
		fontWeight: 100,
		fontStyle: "italic"
	},
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Light Regular'), url(${SharpSansLightEOT}?#iefix) format('embedded-opentype'), url(${SharpSansLightWOFF}) format('woff'), url(${SharpSansLightWOFF2}) format('woff2')`,
		fontWeight: 200,
		fontStyle: "normal"
	},
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Light Italic'), url(${SharpSansLightItalicEOT}?#iefix) format('embedded-opentype'), url(${SharpSansLightItalicWOFF}) format('woff'), url(${SharpSansLightItalicWOFF2}) format('woff2')`,
		fontWeight: 200,
		fontStyle: "italic"
	},
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Book Regular'), url(${SharpSansBookEOT}?#iefix) format('embedded-opentype'), url(${SharpSansBookWOFF}) format('woff'), url(${SharpSansBookWOFF2}) format('woff2')`,
		fontWeight: 300,
		fontStyle: "normal"
	},
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Book Italic'), url(${SharpSansBookItalicEOT}?#iefix) format('embedded-opentype'), url(${SharpSansBookItalicWOFF}) format('woff'), url(${SharpSansBookItalicWOFF2}) format('woff2')`,
		fontWeight: 300,
		fontStyle: "italic"
	},
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Medium Regular'), url(${SharpSansMediumEOT}?#iefix) format('embedded-opentype'), url(${SharpSansMediumWOFF}) format('woff'), url(${SharpSansMediumWOFF2}) format('woff2')`,
		fontWeight: 400,
		fontStyle: "normal"
	},
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Medium Italic'), url(${SharpSansMediumItalicEOT}?#iefix) format('embedded-opentype'), url(${SharpSansMediumItalicWOFF}) format('woff'), url(${SharpSansMediumItalicWOFF2}) format('woff2')`,
		fontWeight: 400,
		fontStyle: "italic"
	},
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Semibold Regular'), url(${SharpSansSemiboldEOT}?#iefix) format('embedded-opentype'), url(${SharpSansSemiboldWOFF}) format('woff'), url(${SharpSansSemiboldWOFF2}) format('woff2')`,
		fontWeight: 500,
		fontStyle: "normal"
	},
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Semibold Italic'), url(${SharpSansSemiboldItalicEOT}?#iefix) format('embedded-opentype'), url(${SharpSansSemiboldItalicWOFF}) format('woff'), url(${SharpSansSemiboldItalicWOFF2}) format('woff2')`,
		fontWeight: 500,
		fontStyle: "italic"
	},
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Bold Regular'), url(${SharpSansBoldEOT}?#iefix) format('embedded-opentype'), url(${SharpSansBoldWOFF}) format('woff'), url(${SharpSansBoldWOFF2}) format('woff2')`,
		fontWeight: 700,
		fontStyle: "normal"
	},
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Bold Italic'), url(${SharpSansBoldItalicEOT}?#iefix) format('embedded-opentype'), url(${SharpSansBoldItalicWOFF}) format('woff'), url(${SharpSansBoldItalicWOFF2}) format('woff2')`,
		fontWeight: 700,
		fontStyle: "italic"
	},
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Extrabold Regular'), url(${SharpSansExtraboldEOT}?#iefix) format('embedded-opentype'), url(${SharpSansExtraboldWOFF}) format('woff'), url(${SharpSansExtraboldWOFF2}) format('woff2')`,
		fontWeight: 800,
		fontStyle: "normal"
	},
	{
		fontFamily: "Sharp Sans",
		src: `local('Sharp Sans Extrabold Italic'), url(${SharpSansExtraboldItalicEOT}?#iefix) format('embedded-opentype'), url(${SharpSansExtraboldItalicWOFF}) format('woff'), url(${SharpSansExtraboldItalicWOFF2}) format('woff2')`,
		fontWeight: 800,
		fontStyle: "italic"
	}
];

export default SharpSans;
